<template>
  <section v-if="book">
    <!-- 書名 -->
    <h5 class="text-primary font-weight-bold mb-3">{{ book.title }}</h5>
    <!-- 作者 -->
    <p v-if="book.author" class="mb-3">{{ book.author }}</p>
    
    <!-- 書籍詳細館藏資訊表格 -->
    <table class="table table-bordered mt-3">
      <tbody>
        <tr v-if="book.publisher">
          <th>{{ $t('lendable-book.detail.table.header.publisher') }}</th>
          <td>{{ book.publisher }}</td>
        </tr>
        <tr v-if="book.publication_year">
          <th>{{ $t('lendable-book.detail.table.header.publication-year') }}</th>
          <td>{{ book.publication_year }}</td>
        </tr>
        <tr v-if="book.edition">
          <th>{{ $t('lendable-book.detail.table.header.edition') }}</th>
          <td>{{ book.edition }}</td>
        </tr>
        <tr v-if="book.isbn">
          <th>{{ $t('lendable-book.detail.table.header.isbn') }}</th>
          <td>{{ book.isbn }}</td>
        </tr>
        <tr v-if="book.call_number">
          <th>{{ $t('lendable-book.detail.table.header.call-number') }}</th>
          <td>{{ book.call_number }}</td>
        </tr>
        <tr v-if="book.binding">
          <th>{{ $t('lendable-book.detail.table.header.binding') }}</th>
          <td>{{ book.binding }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import i18n from '@/plugins/i18n.js'

/**
 * 可借閱經典詳細資訊組件 (Lendable Book Info)
 */
export default {
  i18n,
  name: 'lendable-book-info',
  props: {
    // 可借閱書籍資料物件
    book: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* 確保表格標題文字置中或有適當 padding */
th {
  background-color: #f8f9fe;
  font-weight: 600;
}
</style>
